<mat-form-field
  [appearance]="appearance"
  [class]="[hideRequiredMarker ? 'hideRequiredMarker' : '', classes]"
>
  <mat-label>{{ label }}</mat-label>
  <input matInput
         #inputElement
         [placeholder]="placeholder"
         [formControl]="control"
         [type]="type"
         [required]="required"
         [autocomplete]="autocomplete"
         [value]="value"
         (focusout)="onFocusOut($event)"
         (keydown.enter)="onEnter($event)"
  />
  @if (control.hasError('required') ) {
    <mat-error>{{label? label : 'This field' }} is <strong>required</strong></mat-error>
  }
  @else if (control.hasError('email') ) {
    <mat-error>Invalid email address</mat-error>
  }
</mat-form-field>
